import React, {useEffect, useState} from 'react';
import {Doughnut} from "react-chartjs-2";

const MonthProgress = () => {
  const [data, setData] = useState(null)

  useEffect(() => {
    let style = getComputedStyle(document.body);
    let blue100 = style.getPropertyValue('--blue-100');
    let blue400 = style.getPropertyValue('--blue-400');
    let blue700 = style.getPropertyValue('--blue-700');

    const dataConfig = {
      datasets: [{
        data: [40, 35, 25],
        backgroundColor: [blue100, blue400, blue700],
        hoverBackgroundColor: [blue100, blue400, blue700],
        hoverBorderWidth: [0, 0, 0],
        weight: 2,
        // borderAlign: 'inner',
      }],
      labels: [
        'Nóminas',
        'Liquidaciones',
        'En proceso'
      ],
    };

    setData(dataConfig)
  }, [])

  return data ? (
    <div className="s-relative">
      <div className="s-to-center s-80 m-65 lg-75">
        <Doughnut
          data={data}
          width="70"
          height="70"
          options={{
            maintainAspectRatio: true,
            cutoutPercentage: 0,
          }}
        />
      </div>
    </div>
  ) : null
};

export default MonthProgress;
